var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-toolbar',{staticClass:"action-icons-bar",style:({
      'background-color': _vm.getWebchat().campaign.color,
    }),attrs:{"height":"67px"}},[_c('v-toolbar-title',[(_vm.getWebchat().isLowRes)?_c('v-btn',{staticClass:"left-arrow-back",attrs:{"icon":""},nativeOn:{"click":function($event){return _vm.minimizeWindow.apply(null, arguments)}}},[_c('v-icon',{staticStyle:{"margin-top":"12px"},style:({
            color: _vm.invertColor(_vm.getWebchat().campaign.color),
          }),attrs:{"x-large":""}},[_vm._v("mdi-chevron-left")])],1):_vm._e(),(
          _vm.getWebchat().campaign.show_agent &&
          !_vm.getWebchat().interaction.transfering
        )?_c('div',{staticClass:"avatar-agent-pic",class:{
          isLowRes: _vm.getWebchat().isLowRes,
        },style:({
          'background-image': 'url(' + _vm.getWebchat().menu.menu_img + ')',
        })}):(
          !_vm.getWebchat().campaign.show_agent &&
          !_vm.getWebchat().interaction.transfering &&
          _vm.getWebchat().campaign.logo
        )?_c('div',{staticClass:"avatar-agent-pic",class:{
          isLowRes: _vm.getWebchat().isLowRes,
        },style:({
          'background-image': 'url(' + _vm.getWebchat().campaign.logoName + ')',
        })}):(!_vm.getWebchat().interaction.transfering)?_c('div',{staticClass:"avatar-agent-pic",class:{
          isLowRes: _vm.getWebchat().isLowRes,
        },style:({ 'background-image': 'url(' + _vm.avatar + ')' })}):(_vm.getWebchat().interaction.transfering)?_c('div',{staticClass:"avatar-agent-pic",class:{
          isLowRes: _vm.getWebchat().isLowRes,
        }},[_c('v-icon',{staticClass:"spinIcon",staticStyle:{"font-size":"50px !important"},style:({
            color: _vm.invertColor(_vm.getWebchat().campaign.color),
          })},[_vm._v(" mdi-autorenew ")])],1):_vm._e(),(
          _vm.getWebchat().campaign.show_agent &&
          !_vm.getWebchat().interaction.transfering
        )?_c('span',{staticClass:"agent-name",class:{
          isLowRes: _vm.getWebchat().isLowRes,
        },style:({
          color: _vm.invertColor(_vm.getWebchat().campaign.color),
        })},[_vm._v(_vm._s(_vm.getWebchat().interaction.agent))]):(
          !_vm.getWebchat().campaign.show_agent &&
          !_vm.getWebchat().interaction.transfering
        )?_c('span',{staticClass:"agent-name",class:{
          isLowRes: _vm.getWebchat().isLowRes,
        },style:({
          color: _vm.invertColor(_vm.getWebchat().campaign.color),
        })},[_vm._v("CHAT")]):(_vm.getWebchat().interaction.transfering)?_c('span',{staticClass:"agent-name",class:{
          isLowRes: _vm.getWebchat().isLowRes,
        },style:({
          color: _vm.invertColor(_vm.getWebchat().campaign.color),
        })},[_vm._v(_vm._s(_vm.$t("transfering")))]):_vm._e(),(!_vm.getWebchat().interaction.transfering)?_c('p',{staticClass:"response-time",class:{
          isLowRes: _vm.getWebchat().isLowRes,
        },style:({
          color: _vm.invertColor(_vm.getWebchat().campaign.color),
        })},[_vm._v(" "+_vm._s(_vm.$t("available"))+" ")]):_vm._e()],1),_c('v-spacer'),_c('v-toolbar-items',[(
          _vm.allowedCalls &&
          _vm.hasWebRTC &&
          !_vm.hideButtons &&
          !_vm.getWebchat().interaction.transfering
        )?_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [_c('v-btn',_vm._g({attrs:{"disabled":_vm.isInCall,"id":"btn-videocall","icon":""},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.videoCall.apply(null, arguments)}}},on),[_c('v-icon',{style:({
                color: _vm.invertColor(_vm.getWebchat().campaign.color),
              })},[_vm._v("mdi-video")])],1)]}}],null,false,3530816811)},[_c('span',[_vm._v(_vm._s(_vm.$t("videocall")))])]):_vm._e(),(
          _vm.allowedCalls &&
          _vm.hasWebRTC &&
          !_vm.hideButtons &&
          !_vm.getWebchat().interaction.transfering
        )?_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [_c('v-btn',_vm._g({attrs:{"disabled":_vm.isInCall,"id":"btn-call","icon":""},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.makeCall.apply(null, arguments)}}},on),[_c('v-icon',{style:({
                color: _vm.invertColor(_vm.getWebchat().campaign.color),
              })},[_vm._v("mdi-phone")])],1)]}}],null,false,774472900)},[_c('span',[_vm._v(_vm._s(_vm.$t("call")))])]):_vm._e(),(_vm.allowedAccessibilityOptions)?_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [_c('v-btn',_vm._g({attrs:{"icon":""},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.openAccessibilityModal.apply(null, arguments)}}},on),[_c('v-icon',{style:({
                color: _vm.invertColor(_vm.getWebchat().campaign.color),
              })},[_vm._v("mdi-human ")])],1)]}}],null,false,1223347139)},[_c('span',[_vm._v(_vm._s(_vm.$t("accessibility")))])]):_vm._e(),_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [_c('v-btn',_vm._g({attrs:{"icon":""},nativeOn:{"click":function($event){return _vm.openCloseModal.apply(null, arguments)}}},on),[_c('v-icon',{style:({
                color: _vm.invertColor(_vm.getWebchat().campaign.color),
              })},[_vm._v("mdi-close")])],1)]}}])},[_c('span',[_vm._v(_vm._s(_vm.$t("endchat")))])])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }